import { useCallback } from 'react';
import { connect } from 'react-redux';

import { makeGetMilestone } from 'selectors/milestones';

import { showModal } from 'actions/modal';

const MilestoneTemplateCreateButton = ({ id, milestoneName, milestoneIsList, milestoneStartDate, milestoneEndDate, milestoneDescription, milestoneLabels, className, onClick, children }) => {
    const handleClick = useCallback(() => {
        showModal('CREATE_TEMPLATE', {
            resourceId: id,
            name: milestoneName,
            type: 'milestone',
            fields: [
                !milestoneIsList && milestoneStartDate ? { type: 'start', value: milestoneStartDate } : null,
                !milestoneIsList && milestoneEndDate ? { type: 'end', value: milestoneEndDate } : null
            ].filter(Boolean),
            disabledOptions: [
                !milestoneDescription ? 'description' : null,
                !milestoneEndDate ? 'end' : null,
                !milestoneStartDate ? 'start' : null,
                !milestoneLabels?.length ? 'labels' : null
            ].filter(Boolean)
        });

        onClick?.();
    }, [id, milestoneName, milestoneIsList, milestoneDescription, milestoneStartDate, milestoneEndDate, milestoneLabels, onClick]);

    return (
        <div className={className} onClick={handleClick}>
            { children }
        </div>
    );
}

const makeMapStateToProps = () => {
    const getMilestone = makeGetMilestone();

    return ({ milestones }, ownProps) => {
        const milestone = getMilestone(milestones.items, ownProps.id);

        return {
            milestoneName: milestone?.name,
            milestoneDescription: milestone?.description,
            milestoneIsList: milestone?.is_list,
            milestoneStartDate: milestone?.start,
            milestoneEndDate: milestone?.end,
            milestoneLabels: milestone?.labels
        };
    };
}

export default connect(makeMapStateToProps)(MilestoneTemplateCreateButton);
